module.exports = __webpack_public_path__ + "img/undraw_fast_loading_0lbh.ae990daa.svg";